import { useState } from "react";

import Toolbar from "../Toolbar/Toolbar";
import SideDrawer from "../SideDrawer/SideDrawer";
import Footer from "../Footer/Footer";

const Layout = (props) => {
    const [openDrawer, setOpenDrawer] = useState(false);

    const openDrawerHandler = () => {
        setOpenDrawer(true);
    }

    const closeDrawerHandler = () => {
        setOpenDrawer(false);
    }

    return (
        <>
            <Toolbar openDrawer={openDrawerHandler} />
            <SideDrawer openDrawer={openDrawer} closeDrawer={closeDrawerHandler} />
            <main>{props.children}</main>
            <Footer />
        </>

    );
}


export default Layout;